import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { Section, Breadcrumbs } from "@/components/site/Sections";
import { LOCATIONS } from "@/components/site/locations";
import { BLOG_POSTS } from "@/components/site/blog-posts";

const TITLE = "Sitemap | Elektriker-Elektriker";
const DESCRIPTION = "Oversigt over alle sider på elektriker-elektriker.dk.";

export const Route = createFileRoute("/sitemap")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "/sitemap" },
    ],
    links: [{ rel: "canonical", href: "https://elektriker-elektriker.dk/sitemap" }],
  }),
  component: SitemapPage,
});

const main = [
  ["/", "Forside"],
  ["/om-os", "Om elektriker"],
  ["/ydelser", "Ydelser"],
  ["/kontakt", "Kontakt"],
  ["/careers", "Karriere"],
  ["/tilbud", "Indhent tilbud"],
  ["/priser-privat", "Priser privat"],
  ["/priser-erhverv", "Priser erhverv"],
  ["/blog", "Blog"],
  ["/byer", "Byer og områder"],
];

const services = [
  ["/ladestandere", "Ladestandere"],
  ["/varmepumper", "Varmepumper"],
  ["/energioptimering", "Energioptimering"],
  ["/groen-energi", "Grøn energi"],
  ["/fejlfinding", "Fejlfinding"],
  ["/baeredygtighed", "Bæredygtighed"],
];

function SitemapPage() {
  return (
    <SiteShell>
      <Breadcrumbs items={[{ label: "Forside", to: "/" }, { label: "Sitemap" }]} />
      <Section>
        <h1 className="text-4xl">Sitemap</h1>
        <p className="mt-3 text-muted-foreground">En komplet oversigt over alle sider.</p>

        <div className="mt-10 grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          <div>
            <h2 className="text-lg font-semibold text-[var(--ink)]">Hovedsider</h2>
            <ul className="mt-3 space-y-2 text-sm">
              {main.map(([to, label]) => (
                <li key={to}><Link to={to} className="text-[var(--ink)]/80 hover:text-primary">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[var(--ink)]">Ydelser</h2>
            <ul className="mt-3 space-y-2 text-sm">
              {services.map(([to, label]) => (
                <li key={to}><Link to={to} className="text-[var(--ink)]/80 hover:text-primary">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[var(--ink)]">Blog</h2>
            <ul className="mt-3 space-y-2 text-sm">
              {BLOG_POSTS.map((p) => (
                <li key={p.slug}><Link to={`/${p.slug}` as string} className="text-[var(--ink)]/80 hover:text-primary">{p.title}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-lg font-semibold text-[var(--ink)]">Områder vi dækker</h2>
          <ul className="mt-3 grid grid-cols-2 gap-x-6 gap-y-2 text-sm sm:grid-cols-3 lg:grid-cols-4">
            {LOCATIONS.map((l) => (
              <li key={l.slug}>
                <Link to={`/${l.slug}` as string} className="text-[var(--ink)]/80 hover:text-primary">
                  Elektriker {l.city}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </Section>
    </SiteShell>
  );
}
